//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import POL_BASIC_01 from './POL_BASIC_01';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import useDelete from '../../../../hooks/useDeleteN';
import { useSearch1, useSave1, useDelete1 } from './POL_BASIC_01_QUERY';
import { useSave } from '../../../../hooks/useSaveN';
import { POL_BASIC_01_Schema } from './POL_BASIC_01_Schema';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import useFileUpload from '../../../../hooks/useFileUpload';
import { v4 as uuidv4 } from 'uuid';
import { setSelected } from '../../../../Reducer/GridReducer';
import isEqual from 'lodash/isEqual';

import SunEditor from 'suneditor-react';
import { ko } from 'suneditor/src/lang';
import 'suneditor/dist/css/suneditor.min.css';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import { createInitial } from '../../../../util';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'PolicyAndGoals';

//#region 상수
const COL_WIDTH = ['20%', '80%'];
//#endregion

function POL_BASIC_01F(props) {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  // 파일 업로드 관련 Hook
  const { SaveLogicPreview, SaveLogicFile, DeleteLogicFile } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: () => {
      const coCd =
        userInfo.authCd === 'ADMIN' ? searchInfo.coCd : userInfo.coCd;
      return `PolicyAndGoals/${coCd}/POL_BASIC_01`;
    },
  });

  const [inputs, setInputs] = useState(() =>
    createInitial(POL_BASIC_01_Schema)
  );
  const inputRef = useRef(null); //추가 버튼 시 포커스
  //#region 그리드 , 폼 변수
  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const gridRef1 = useRef(); // 사전준비
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);
  const currentRowDataRef1 = useRef();
  //#endregion
  const editorRef = useRef(null);
  const latestHtmlRef = useRef('');
  const [viewMode, setViewMode] = useState('table'); // preview / table 랜더링 변수

  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.chaebun,
    getKeyFromResult: (result) => result.chaebun,
  });

  const updateCurrentRowData = (fieldName, value, skipValidation = false) => {
    if (!gridRef1.current || currentRowIndexRef1.current === null) return;

    const api = gridRef1.current.api;
    const rowNode = api.getDisplayedRowAtIndex(currentRowIndexRef1.current);
    if (!rowNode) return;

    const prevData = rowNode.data;

    // 값이 실제로 변경되지 않았으면 return
    if (prevData[fieldName] === value) return;

    if (fieldName === 'comment' && prevData.fileName) return;

    const updatedRowData = {
      ...prevData,
      [fieldName]: value,
      editYn: 'Y',
    };

    // ✅ row 전체 갱신
    rowNode.setData(updatedRowData);

    // ✅ 상태 업데이트: 최신 prev 기반으로 변경
    setChangedRowData1((prev) => {
      const alreadyChangedIndex = prev.findIndex(
        (item) => item.no === updatedRowData.no
      );
      if (alreadyChangedIndex > -1) {
        const newList = [...prev];
        newList[alreadyChangedIndex] = updatedRowData;
        return newList;
      }
      return [...prev, updatedRowData];
    });
  };

  //#region 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (processedRows) => {
      setRowData1(processedRows);
      dispatch(closeLoading());
    },
  });

  const SearchLogic1 = async () => {
    // 회사/사업장 정보 체크
    if (!props.validateSelection()) {
      setRowData1([]);
      ResetLogic();
      return;
    }
    dispatch(showLoading());
    await Search1();
  };

  const ResetLogic = () => {
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };
  //#endregion

  //#region 삭제
  const delete1 = useDelete1();

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });
  //#endregion

  const htmlText = inputs.fileName
    ? '<div>자사 양식을 업로드한 경우 수정이 불가합니다.</div>'
    : inputs.comment;

  const handleEditorChange = (e) => {
    // 최신 입력값 저장
    latestHtmlRef.current = e;

    const api = gridRef1.current.api;
    const rowNode = api.getDisplayedRowAtIndex(currentRowIndexRef1.current);
    if (!rowNode) return;

    const current = currentRowDataRef1.current;

    // ✅ 파일 여부 관계없이 comment 값이 바뀌었을 때만 update
    if (current?.comment !== e) {
      setInputs((preState) => ({
        ...preState,
        comment: e,
        newYn: current?.newYn ?? 'N',
      }));

      updateCurrentRowData('comment', e);
    }
  };

  const tableData = [
    {
      cells: [
        {
          gubun: 'R',
          content: '내용',
        },
        {
          gubun: 'I',
          type: 'other',
          align: 'start',
          item: (
            <div>
              {/* 폰트 기본값, 테두리 스타일 */}
              <style>
                {`
                  .sun-editor-editable {
                    font-family: '맑은 고딕' !important;
                  }
                  .sun-editor {
                  border: 1px solid #ccc;
                  border-radius: 8px !important;
                  overflow: hidden !important;
                  }
                `}
              </style>
              <SunEditor
                onLoad={(editor) => {
                  editorRef.current = editor; // ref를 수동으로 할당
                }}
                setContents={htmlText}
                onChange={handleEditorChange}
                currentRowIndex={currentRowIndexRef1.current}
                setOptions={{
                  lang: ko,
                  font: [
                    '굴림체',
                    '궁서체',
                    '돋움체',
                    '맑은 고딕',
                    '바탕체',
                    'Arial',
                    'Comic Sans MS',
                    'Courier New',
                    'Georgia',
                    'Impact',
                    'Tahoma',
                    'Times New Roman',
                    'Verdana',
                  ],
                  buttonList: [
                    ['undo', 'redo'],
                    ['font', 'fontSize'],
                    // ['paragraphStyle', 'blockquote'],
                    [
                      'bold',
                      'underline',
                      // "italic",
                      // "strike", // 취소선
                      'subscript',
                      'superscript',
                    ],
                    ['fontColor', 'hiliteColor'],
                    [
                      'align',
                      'list',
                      // "lineHeight" // 행간
                    ],
                    // ["outdent", "indent"], // 들여쓰기, 내어쓰기

                    // ["table", "horizontalRule", "link", "image", "video"], // 테이블, 줄긋기, 링크, 이미지, 동영상
                    // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
                    // ['imageGallery'], // You must add the "imageGalleryUrl".
                    // ["fullScreen", "showBlocks", "codeView"],
                    [
                      // "preview", // 미리보기
                      'print',
                    ],
                    ['removeFormat'],

                    // ['save', 'template'],
                    // '/', Line break
                  ], // Or Array of button list, eg. [['font', 'align'], ['image']]
                  defaultTag: 'div',
                  overflow: 'auto',
                  minHeight: '450px',
                  showPathLabel: false,
                  // font: sortedFontOptions
                  defaultStyle:
                    "font-family: '맑은 고딕', sans-serif; font-size: 16px;", // 기본값 설정
                }}
                disable={inputs.fileName ? true : false}
              />
            </div>
          ),
          field: 'comment', // 필수
          inputRef: inputRef,
        },
      ],
    },
  ];
  //#endregion

  useEffect(() => {
    if (props.searchClick1 || props.filterClick1) {
      // 회사/사업장 정보 체크
      if (!props.validateSelection()) {
        setRowData1([]);
        ResetLogic();
        props.setSearchClick1?.(false);
        props.setFilterClick1?.(false);
        return;
      }
      SearchLogic1();
      props.setSearchClick1?.(false);
      props.setFilterClick1?.(false);
    }
  }, [props.searchClick1, props.filterClick1]);

  // preview / editor 스위치
  useEffect(() => {
    const selected = selectedRowData1[0];

    if (selected?.fileName) {
      setViewMode('preview');
    } else {
      setViewMode('table');
    }
  }, [selectedRowData1]);
  //#region 저장
  //저장버튼 클릭 시 함수()
  const { runAsync: Save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '내용',
    schema: POL_BASIC_01_Schema,
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRowData1,

    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: (rows) => Save1Async(rows),
    fileDelete: DeleteLogicFile,

    fileSave: (item) => {
      const _coCd =
        userInfo.authCd === 'ADMIN' ? searchInfo.coCd : userInfo.coCd || '';
      return SaveLogicFile(item, _coCd);
    },

    reset: ResetLogic,
    refresh: Search1,

    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search1,
      }),
  });

  //#endregion

  //#region 나머지 함수
  // 파일 다운로드
  const DownloadLogic2 = async (_data) => {
    if (_data.newYn === 'Y') {
      dispatch(
        showSnackbar({
          message: '저장 후 파일 다운로드가 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }

    if (!_data.filePath) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = Commons.EncodeUrl(_data.filePath);
      const fileName = _data.fileName || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  // 추가 버튼 클릭 이벤트
  const HandleAddClick = async (_gridRef) => {
    dispatch(setSelected({ gridId: 'grid1', selected: [] }));
    if (_gridRef) {
      const api = _gridRef.current.api;
      inputRef.current?.focus(); //첫번째 입력란으로 포커스 이동
      api.deselectAll();

      const newRow = {
        ...inputs,
        no: uuidv4(), // 신규 행 고유 ID
        newYn: 'Y',
      };
      _gridRef.current.api.applyTransaction({
        add: [newRow],
        addIndex: 0,
      });
      const addedRowNode = _gridRef.current.api.getDisplayedRowAtIndex(0);
      if (addedRowNode) {
        setInputs(addedRowNode.data);
        currentRowIndexRef1.current = 0;
        addedRowNode.setSelected(true);
      }
    }
  };
  const handleRowSelection = (rowData, rowIndex) => {
    const defaultComment = inputs.comment;
    const selectedComment =
      rowData.comment && rowData.comment.trim() !== ''
        ? rowData.comment
        : defaultComment;

    const newInputs = {
      ...rowData,
      comment: selectedComment,
    };
    // 기존 inputs와 비교 후 변경이 있을 때만 setInputs 호출
    if (!isEqual(inputs, newInputs)) {
      setInputs(newInputs);
    }

    currentRowIndexRef1.current = rowIndex;
    dispatch(setSelected({ gridId: 'grid1', selected: [rowData] }));
  };
  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };
  //인쇄 함수
  const PrintLogic1 = async () => {
    dispatch(showLoading());

    try {
      if (!selectedRowData1 || selectedRowData1.length === 0) {
        dispatch(
          showSnackbar({
            message: '인쇄할 데이터를 선택하세요.',
            type: 'error',
          })
        );
        return null;
      } else {
        selectedRowData1.map(async (item) => {
          if (item.fileName !== '') {
            dispatch(
              showSnackbar({
                message: '자사 양식을 업로드한 경우 미리보기로 확인가능합니다.',
                type: 'warning',
              })
            );
            return null;
          }

          const printData = {
            FileName: 'POL_BASIC_01',
            HeaderData: JSON.stringify(item),
          };
          await Commons.Axios(
            'report',
            Global.base.useUrl + Global.urls.Reports.reports,
            printData
          ).then((response) => {
            const blobUrl = URL.createObjectURL(response.data);
            window.open(blobUrl, '_blank'); // 새 탭에서 열기
          });
        });
      }
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };

  //#endregion
  return (
    <div className="wrap">
      <POL_BASIC_01
        gridId1={'grid1'}
        inputs={inputs}
        setInputs={setInputs}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        deletedRowData1={deletedRowData1}
        userInfo={userInfo}
        gridRef1={gridRef1}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        tableData={tableData}
        colWidth={COL_WIDTH}
        inputRef={inputRef}
        filterClick1={props.filterClick1}
        setFilterClick1={props.setFilterClick1}
        searchClick1={props.searchClick1}
        setSearchClick1={props.setSearchClick1}
        addClick1={props.addClick1}
        setAddClick1={props.setAddClick1}
        saveClick1={props.saveClick1}
        setSaveClick1={props.setSaveClick1}
        deleteClick1={props.deleteClick1}
        setDeleteClick1={props.setDeleteClick1}
        printClick1={props.printClick1}
        setPrintClick1={props.setPrintClick1}
        listClick1={props.listClick1}
        setListClick1={props.setListClick1}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 함수
        ResetLogic={ResetLogic}
        validateSelection={props.validateSelection}
        SearchLogic1={SearchLogic1}
        SaveLogic1={Save1}
        SaveLogicPreview={SaveLogicPreview}
        DownloadLogic2={DownloadLogic2}
        PrintLogic1={PrintLogic1}
        handleRowSelection={handleRowSelection}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        RestoreRow1={deleteHandler1.RestoreRow}
        HandleAddClick={HandleAddClick}
        NewYnErrorMsg={NewYnErrorMsg}
        updateCurrentRowData={updateCurrentRowData}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        viewMode={viewMode}
      />
    </div>
  );
}

export default POL_BASIC_01F;
